import React, { memo } from 'react';
import { Button, Tooltip } from 'antd';
import { ReactComponent as FolderSvg } from '@assets/icons/folder.svg';
import { ReactComponent as PrivateFolderSvg } from '@assets/icons/folder-private.svg';
import { ReactComponent as DownloadInvoiceSvg } from '@assets/icons/download-invoice.svg';
import TilesViewItem from './TilesViewItem';
import { downloadAll } from '@helpers/download';
import { AssetItemDto } from '@api/Api';

import './TilesView.less';

type TilesViewProps = {
  onSelectFolder: (folderId: string) => void;
  folders: {
    id: string;
    name: string;
    isPrivate: boolean;
    items: AssetItemDto[];
  }[];
  assetsList: AssetItemDto[];
  isOpenFolder: boolean;
};
export default memo(function TilesView({
  onSelectFolder,
  folders,
  assetsList,
  isOpenFolder
}: TilesViewProps) {
  return (
    <div className="assets-tiles-view">
      {!!folders?.length && (
        <div className="assets-tiles-view-folders">
          <div className="assets-tiles-view-label">Folders</div>
          <div className="assets-tiles-view-folders-list">
            {folders.map((folder) => {
              const assetsToDownload = folder.items.filter(
                (asset) => !!asset.asset?.permissions.download
              );
              return (
                <Tooltip
                  key={folder.id}
                  title={folder.name}
                  overlayClassName="external_reviewer_tooltip"
                >
                  <div
                    className="assets-tiles-view-folder"
                    onClick={() => onSelectFolder(folder.id)}
                  >
                    {folder.isPrivate ? <PrivateFolderSvg /> : <FolderSvg />}
                    <div className="assets-tiles-view-folder-name">
                      {folder.name}
                    </div>
                    <Button
                      type="text"
                      size="small"
                      className="assets-list-btn-download"
                      disabled={!assetsToDownload?.length}
                      icon={<DownloadInvoiceSvg />}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!assetsToDownload?.length) return;
                        downloadAll(
                          assetsToDownload,
                          `${folder.name}.zip`,
                          folder.id
                        );
                      }}
                    />
                  </div>
                </Tooltip>
              );
            })}
          </div>
        </div>
      )}
      {!!assetsList?.length && (
        <div className="assets-tiles-view-assets">
          <div className="assets-tiles-view-label">Media</div>
          <div className="assets-tiles-view-assets-list">
            {assetsList.map((item) => {
              return <TilesViewItem key={item.id} asset={item} />;
            })}
          </div>
        </div>
      )}
    </div>
  );
});
